import Swiper from 'swiper/bundle';

import 'swiper/css/bundle';
import '../scss/blocks/swiper-overrides.scss';

/**
 * @param {Element} swiperContainer
 */
function initSwiperContainer(swiperContainer) {
    if (!(swiperContainer instanceof Element)) {
        return;
    }

    if (swiperContainer.swiper) {
        swiperContainer.swiper.destroy(true, true);
    }

    let nextButton = swiperContainer.querySelector('.swiper-button-next');
    let prevButton = swiperContainer.querySelector('.swiper-button-prev');

    if (!nextButton || !prevButton) {
        const parentElement =
            swiperContainer.closest('.swiper-wrapper-parent') || swiperContainer.parentElement;
        if (!nextButton && parentElement) {
            nextButton = parentElement.querySelector('.swiper-button-next');
        }
        if (!prevButton && parentElement) {
            prevButton = parentElement.querySelector('.swiper-button-prev');
        }
    }

    const paginationEl = swiperContainer.querySelector('.swiper-pagination');

    const defaultSlides = parseFloat(swiperContainer.dataset.default) || 1.5;
    const smSlides = parseFloat(swiperContainer.dataset.sm);
    const mdSlides = parseFloat(swiperContainer.dataset.md);
    const lgSlides = parseFloat(swiperContainer.dataset.lg);
    const xlSlides = parseFloat(swiperContainer.dataset.xl);
    const xxlSlides = parseFloat(swiperContainer.dataset.xxl);

    const breakpoints = {};

    if (smSlides) {
        breakpoints[576] = {
            slidesPerView: smSlides,
            spaceBetween: 16,
        };
    }

    if (mdSlides) {
        breakpoints[768] = {
            slidesPerView: mdSlides,
            spaceBetween: 20,
        };
    }

    const lockLg = swiperContainer.dataset.lockLg === '1' || swiperContainer.dataset.lockLg === 'true';

    if (lgSlides) {
        breakpoints[992] = {
            slidesPerView: lgSlides,
            spaceBetween: 20,
        };

        if (lockLg) {
            breakpoints[992].allowTouchMove = false;
            breakpoints[992].simulateTouch = false;
        }
    }

    if (xlSlides) {
        breakpoints[1200] = {
            slidesPerView: xlSlides,
            spaceBetween: 24,
        };
    }

    if (xxlSlides) {
        breakpoints[1400] = {
            slidesPerView: xxlSlides,
            spaceBetween: 24,
        };
    }

    if (Object.keys(breakpoints).length === 0) {
        breakpoints[768] = {
            slidesPerView: 3,
            spaceBetween: 20,
        };
        breakpoints[1200] = {
            slidesPerView: 3,
            spaceBetween: 24,
        };
    }

    const options = {
        slidesPerView: defaultSlides,
        spaceBetween: 16,
        breakpoints,
    };

    if (nextButton && prevButton) {
        options.navigation = {
            nextEl: nextButton,
            prevEl: prevButton,
        };
    }

    if (paginationEl) {
        options.pagination = {
            el: paginationEl,
            clickable: true,
        };
    }

    // eslint-disable-next-line no-new
    new Swiper(swiperContainer, options);
}

/**
 * @param {Document|Element|{0?: Element}|null|undefined} scope
 * @returns {Document|Element}
 */
function resolveSwiperScope(scope) {
    if (!scope) {
        return document;
    }
    if (scope instanceof Element) {
        return scope;
    }
    if (typeof scope === 'object' && scope[0] instanceof Element) {
        return scope[0];
    }
    return document;
}

/**
 * @param {Document|Element|{0?: Element}|null|undefined} [scope]
 */
export function initSwipers(scope = document) {
    resolveSwiperScope(scope).querySelectorAll('.swiper-container').forEach(initSwiperContainer);
}

/**
 * @param {Document|Element|{0?: Element}|null|undefined} [scope]
 */
export function destroySwipers(scope = document) {
    const root = resolveSwiperScope(scope);
    const containers =
        root === document ? document.querySelectorAll('.swiper-container') : root.querySelectorAll('.swiper-container');

    containers.forEach((swiperContainer) => {
        if (swiperContainer.swiper) {
            swiperContainer.swiper.destroy(true, true);
        }
    });
}
